import http from '../axios';
import axios from 'axios';

export function index(payload = {}) {
  return http.get('/operations', {
    params: payload
  });
}

export function update(payload) {
  return http.patch(`/operations/${payload.id}`, payload);
}

export function destroy(id) {
  return http.post('/operations/destroy', { id });
}

export function create(formData){
  return http.post('/operations', {
    params: formData
  });
}

export function show(payload) {
  return http.get(`/operations/${payload.id}`);
}

export function job_clone(id){
  return http.post('/operations/job_clone', {id});
}

export function generate_report(id, isPda){
  return http.get('/operations/generate_report.pdf', {
    params: {
      id,
      is_pda: isPda
    },
    responseType: 'blob'
  });
}

export function generate_vessel_report(id){
  return http.get('/operations/generate_vessel_report.pdf', {
    params: {
      id
    },
    responseType: 'blob'
  });
}

export function generate_msc_report(id){
  return http.get('/operations/generate_msc_report.pdf', {
    params: {
      id
    },
    responseType: 'blob'
  });
}

export function completeJob(id){
  return http.post('/operations/complete_job', {id});
}

export function getDocsApproved(operation_id, remarks_approval = '') {
  return http.get('/operations/get_docs_approved', { 
    params: { 
      operation_id,
      remarks_approval
    }
  });
}

export function submitForApproval(operation_id, manager_id) {
  return http.post('/operations/submit_for_approval', {
    operation_id,
    manager_id
  });
}

export function releasePortCall(operation_id) {
  return http.post('/operations/release_port_call', {
    operation_id
  });
}

export function checkVesselOverlap(vessel_id, eta, etd) {
  return http.get('/operations/check_vessel_overlap', {
    params: {
      vessel_id,
      eta,
      etd
    }
  });
}